



















import { Component, Vue, PropSync, Prop } from 'vue-property-decorator';
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';

  @Component({
    name: 'DSearchBox',
    components: {
      DxTextBox,
      DxTextBoxButton,
    }
  })
  export default class extends Vue {
    @PropSync('filterString') public filterStringArray: any[];
    @Prop({default: 'name'}) public searchField!: string;
    @Prop({default: 'Поиск по названию'}) public placeholder!: string;
    @Prop({default: '250'}) public width!: string;

    private searchString: string = '';

    // строка для запроса фильтрации классов аварийных ситуаций по наименованию
    private setFilterString(e: HTMLFormElement){
      this.searchString = e.event.target.value
      this.filterStringArray = this.searchString
        ? [
          this.searchField,
          'contains',
          this.searchString.replace('%', '\\%').replace('_', '\\_')
        ]
        : [];

      this.$emit('update:filterStringArray', this.filterStringArray)
    }

    created() {
    }


  }
